import Vue from 'vue'

import productitems from './products-list.vue'
import catalogitemcontrols from '../catalog-item/controls.vue'

const productListEl = document.querySelectorAll(".js-product-list");
const productListStartedEl = document.querySelectorAll(".products__started-js");

if (productListEl.length) {
    const productList = new Vue({
        el: '.js-product-list',
        components: {
            productitems
        }
    });
}

if (productListStartedEl.length) {
    const productListStarted = new Vue({
        el: '.products__started-js',
        components: {
            catalogitemcontrols
        }
    });
}

